export default "__VITE_ASSET__Dvod8KE7__"